<script lang="ts">
    import { onMount } from "svelte";
    import "../../../node_modules/mapbox-gl/dist/mapbox-gl.css";
    import type { MapManager } from "./MapManager";

    export let manager: MapManager;
    let container: HTMLElement;
    let initialized: boolean = false;
    
    onMount(async () => {
        await manager.initialize(container);

        initialized = true;
    });
</script>

<div class="h-100">
<div bind:this={container} class="h-100 map">
</div>
{#if initialized}
<slot></slot>
{/if}
</div>

<style>
</style>
